import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { Block as BlockIcon } from '@mui/icons-material';

/**
 * Shown in place of a page or tab whose feature flag is set to false.
 * Keeps navigation intact — only the content area is replaced.
 *
 * Props:
 *   featureName  — display name of the feature (e.g. "Loans")
 *   message      — optional custom message from the API; shown instead of
 *                  the generic fallback text when provided
 */
const DisabledFeatureBanner = ({ featureName = 'This feature', message }) => {
    return (
        <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 3, md: 6 },
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    backgroundColor: '#f9fafb',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    minHeight: '320px',
                    gap: 2,
                }}
            >
                <Box
                    sx={{
                        width: 72,
                        height: 72,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1,
                    }}
                >
                    <BlockIcon sx={{ fontSize: 36, color: '#ef4444' }} />
                </Box>

                <Typography variant="h6" sx={{ fontWeight: 600, color: '#374151' }}>
                    {featureName} is Currently Unavailable
                </Typography>

                <Typography
                    variant="body1"
                    sx={{ color: '#6b7280', maxWidth: 480, lineHeight: 1.6 }}
                >
                    {message ||
                        'This feature has been temporarily disabled by your property manager. Please contact them for assistance or try again later.'}
                </Typography>
            </Paper>
        </Box>
    );
};

export default DisabledFeatureBanner;
